import React from "react";

const WhoWeAre = () => {
  return (
    <div className="bg-[#F0F7FC] py-28">
      <div className="flex flex-col lg:flex-row w-[90%] lg:w-[80%] mx-auto">
        <div className="w-full lg:w-[50%] flex flex-col items-end lg:pr-5 mt-12">
          <div className="lg:w-[85%] xl:w-[65%]">
            <p className="font-popinsMedium text-[#458CB4] text-sm">
              W &nbsp;h &nbsp;o &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;W &nbsp;e
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;A &nbsp;r &nbsp;e
            </p>
            <h4 className="text-btnColor font-popinsBold text-5xl xl:text-6xl mt-3">
              Who We Are
            </h4>
            <p className="font-popinsRegular text-darkColor pt-10">
              FMS is backed by a team of seasoned real estate professionals with over 40 years of combined experience and a track record of more than 1,000 successful real estate transactions across development, investment, and brokerage.
            </p>
          </div>
          <img
            src="/assets/whyflex/who-we-are.jpg"
            alt=""
            className="size-full lg:w-[450px] lg:h-[500px] lg:mr-5 mt-10 object-cover rounded-lg"
          />
        </div>
        <div className="w-full lg:w-[50%] flex flex-col lg:items-end mt-10 lg:mt-0">
          <div className="lg:pl-20 xl:pl-28">
            <p className="font-popinsMedium text-[#458CB4] text-sm">
              W &nbsp;h &nbsp;y &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;U &nbsp;s
            </p>
            <h4 className="text-btnColor font-popinsBold text-5xl xl:text-6xl mt-3">
              Why Us
            </h4>
            <p className="font-popinsRegular text-darkColor pt-10 xl:pr-20">
              With a lengthy career focused on small bay industrial, we have built a system based on the thoughts, input and ideas from flex space owners to help build the ultimate system.
            </p>
          </div>
          <img
            src="/assets/whyflex/why-us.jpg"
            alt=""
            className="size-full lg:w-[450px] lg:h-[500px] mt-4 lg:mt-10 ml-3 object-cover rounded-lg"
          />
        </div>
      </div>
    </div>
  );
};

export default WhoWeAre;
